<template>
  <div id="app">
    <div class='formStep fondo'>
      <b-card>
        <b-form-group>
          <div class='stepTitle'><h2>Envío Masivo por whatsapp</h2></div>
          <b-row class="tituloinput">
            <b-col sm="3">
              <label class="required tituloinput" :for="`mensaje`">Escribí tu mensaje acá 👇🏻 o copia y pega un mensaje de WhatsApp con emojis.</label>
            </b-col>
            <b-col sm="9">
              <b-form-textarea
                class="inputbottom"
                autofocus
                :id="`mensaje`"
                v-model="mensaje"
                v-model.trim="mensaje"
                placeholder="Escribe un mensaje memorable."
                rows="3"
                max-rows="8"
                v-bind:class="{ 'is-invalid': errors.includes('mensaje') }"
              >
              </b-form-textarea>
              <div class="invalid-feedback">Campo obligatorio</div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="txt-align espacioarriba tituloinput" sm="12">
             <b>Subi la imagen para el envio</b>
            </b-col>
          </b-row>
          <b-list-group flush>
            	<progress id="uploader" value="0" max="100">0%</progress>
            	<input id="fileButton" capture="camara" type="file" accept="image/*,.pdf">
            	<em id="urlArchivo">{{urlArchivo}}</em>
                <em id="sessionId">{{sessionId}}</em>
            	<div class="text-center">
                <b-spinner id="loader" class="Disp-none" label="Spinning"></b-spinner>
            	</div>
      	  </b-list-group>
          <b-row class="espacioarriba tituloinput">
            <b-col sm="3">
              <label class="required tituloinput" :for="`fonodeprueba`">Agrega un número de WhatsApp para hacer un envío de prueba.</label>
            </b-col>
            <b-col sm="9">
              <b-form-input
                class="inputbottom"
                autofocus
                :id="`fonodeprueba`"
                v-model="fonodeprueba"
                v-model.trim="fonodeprueba"
                placeholder="59894197353"
                type="tel"
                v-bind:class="{ 'is-invalid': errors.includes('fonodeprueba') }"
              >
              </b-form-input>
              <div class="invalid-feedback">Campo obligatorio</div>
            </b-col>
          </b-row>
          <div class='buttonNavigation'>
            <b-button id="btnSiguiente" class='nextButton agrandado btn-uploader' @click="CheckForm()">Enviar Test</b-button>
          </div>
          


          
          <div id="errores" class="disp-none">Tienes campo incompletos</div>
        </b-form-group>
      </b-card>
    </div>
  </div>
</template>

<script>

import createMomentsSDK from '@livechat/moments-sdk/es5';

const axios = require('axios').default;

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.post['Access-Control-Allow-Methods'] = 'POST, OPTIONS';
axios.defaults.headers.post['Access-Control-Allow-Headers'] = 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers,X-Access-Token,XKey,Authorization';

export default {
  props: [
    "accountType",
    'sessionId',
    'momentsSDK',
  ],
  data() {
    return {
      mensaje: '',
      fonodeprueba: '',
      infobase: '',
      errors: [],
      picture: null,
      UploadValue: 0,
      selectedFile: null,
      urlArchivo: "",
    };
  },
  async created() {
    var script = document.createElement('script');
			script.src = 'https://code.jquery.com/jquery-3.4.1.min.js';
			script.type = 'text/javascript';
			document.getElementsByTagName('head')[0].appendChild(script);
    	let script1 = document.createElement(`script`)
      script1.src = "js/subirArchivo.js"
        document.body.appendChild(script1)
    if (!this.momentsSDK) {
      createMomentsSDK({
        title: 'Demo Wapchita',
      }).then((momentsSDK) => {
        this.momentsSDK = momentsSDK;
      });
    }
  },
  methods: {
    async next1() {
        console.log(this.fonodeprueba);
       this.fonodeprueba = this.fonodeprueba.replace(" ","")
       this.fonodeprueba = this.fonodeprueba.replace("+","")
       this.urlArchivo = document.getElementById("urlArchivo").innerText;
axios
		.post(
			"https://southamerica-east1-obot-55a3f.cloudfunctions.net/DemoEnvio",
			{
			phone: `${this.fonodeprueba}`,
      caption: `${this.mensaje}
            
*Esto es un mensaje de prueba por favor no responder*`,
			}
		)
		.then((response) => {
		    console.log(response);
            $("#loader").addClass("Disp-none");
        window.alert("Mensaje enviado con éxito")
		})
		.catch((error) => {
			console.log(error);
		});

        


      
    },
    async next2() {
      axios
		.post(
			"https://api.chat-api.com/instance182883/message?token=08wm1u3d1m2icrce",
			{
			phone: `59895983155`,
			body: `Tienes una solicitud para sacar un envio a la *base*:
${this.infobase}

*Mensaje*:
${this.mensaje}`,
			}
		)
		.then((response) => {
		    console.log(response);
		})
		.catch((error) => {
			console.log(error);
		});
    },
    async CheckForm() {
      let divErr = document.getElementById("errores")
      this.errors = [];
      if (this.mensaje === '') {
        this.errors.push('mensaje');
        divErr.classList.remove("disp-none")
      }
      if (this.fonodeprueba === '') {
        this.errors.push('fonodeprueba');
        divErr.classList.remove("disp-none")
      }
      if (this.errors.length === 0) {
        divErr.classList.add("disp-none")
        this.next1();
      } 
    },
    async CheckForm2() {
      let divErr = document.getElementById("errores")
      this.errors = [];
      if (this.mensaje === '') {
        this.errors.push('mensaje');
        divErr.classList.remove("disp-none")
      }
      if (this.fonodeprueba === '') {
        this.errors.push('fonodeprueba');
        divErr.classList.remove("disp-none")
      }
      if (this.fonodeprueba === '') {
        this.errors.push('infobase');
        divErr.classList.remove("disp-none")
      }
      if (this.errors.length === 0) {
        divErr.classList.add("disp-none")
        this.next2();
      } 
    },

  },
};
</script>

<style>
label{
  margin-bottom: 0px !important;
  margin-top: 0.55rem !important;
}
.disp-none{
  display: none !important
}
#errores{
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}
.required::after {
  content:" *";
  color: red;
}
.input_form_juntos{
  margin-bottom: 0.2rem !important
}

.espacioarriba{
  margin-top: 3px !important
}

.tituloinput{
  margin-bottom: 10px !important;
}

.inputbottom{
  margin-bottom: 30px;
}

::placeholder{
  color: #999 !important;
}

.agrandado{
  padding: 10px;
}
.Disp-none{
display: none !important;
}
  
.boldtext{
font-weight: bold;
  display: block !important;
}
  
#urlArchivo{
  display: none;
}
#sessionId{
  display: none;
}
.txt-align{
text-align: center;
}
progress{
  display: block;
  margin-left: 25%;
  margin-bottom: 5px;
}
</style>